import { DSTIRecord } from "../../../../models/DSTI/site-dsti-list.interface";
import { Card } from "primereact/card";
import styles from "../sitedsti.module.scss";
import { Checkbox } from "primereact/checkbox";

interface DSTIProps {
  dstiDetails?: DSTIRecord;
}

function DSTI({ dstiDetails }: DSTIProps) {
  return (
    <>
      {dstiDetails?.dsti?.map((dstiItem, index) => {
        return (
          <Card
            key={index}
            title={dstiItem.display_name}
            subTitle={dstiItem.type}
            className={index === 0 ? "mb-4" : "my-4"}
          >
            <div style={{ marginTop: "-30px" }}>
              {dstiItem.hazard && dstiItem.hazard.options && (
                <div className={styles["dsti-item"]}>
                  <p className={"font-bold mt-0"}>Hazard:</p>
                  <div className={styles["responsive-grid-2"]}>
                    {dstiItem.hazard.options.map(hazardItem => {
                      return (
                        <div key={hazardItem.id} className="flex align-items-center gap-2">
                          <Checkbox
                            inputId={`task-${index}`}
                            checked={hazardItem.check}
                            disabled={true}
                          />
                          <label htmlFor={`task-${index}`}>{hazardItem.name}</label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {dstiItem.control_measure && dstiItem.control_measure.options && (
                <div className={styles["dsti-item"]}>
                  <p className={"font-bold mt-0"}>Control measure:</p>
                  <div className={styles["responsive-grid-2"]}>
                    {dstiItem.control_measure.options.map(controlMeasure => {
                      return (
                        <div key={controlMeasure.id} className="flex align-items-center gap-2">
                          <Checkbox
                            inputId={`task-${index}`}
                            checked={controlMeasure.check}
                            disabled={true}
                          />
                          <label htmlFor={`task-${index}`}>{controlMeasure.name}</label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </>
  );
}

export default DSTI;
